import { c as _c } from "react/compiler-runtime";
export interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

// RouterBench logo mark — "Weave" (two flow lines crossing). Square, monochrome;
// inherits currentColor. Callers render the "RouterBench" wordmark separately.
export const Logo = t0 => {
  const $ = _c(5);
  const {
    width,
    height,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g stroke="currentColor" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round"><path d="M9 13 C18 13 20 24 27 24" /><path d="M9 24 H27" /><path d="M9 35 C18 35 20 24 27 24" /><path d="M27 24 H39" /><circle cx="9" cy="13" r="2.4" fill="currentColor" /><circle cx="9" cy="24" r="2.4" fill="currentColor" /><circle cx="9" cy="35" r="2.4" fill="currentColor" /><circle cx="27" cy="24" r="3.4" fill="currentColor" /><circle cx="39" cy="24" r="2.4" fill="currentColor" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== height || $[3] !== width) {
    t2 = <svg viewBox="0 0 48 48" width={width} height={height} className={className} role="img" aria-label="RouterBench" fill="none">{t1}</svg>;
    $[1] = className;
    $[2] = height;
    $[3] = width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};